import type { JSONContent } from '@tiptap/react';
import { migrateShortAnswerAnswerNodesInJson } from './question-set-builder-migration';

export { migrateShortAnswerAnswerAttrs, migrateShortAnswerAnswerNodesInJson } from './question-set-builder-migration';

export function migrateProseMirrorJson(doc: JSONContent): JSONContent {
    return migrateShortAnswerAnswerNodesInJson(doc);
}
